<template>
  <div class="text-center confirmationModal closeConversationConfirmationModal">
      <p class="confirmationModalTitle">{{ getConfirmationText() }}</p>
      <div>
        <button class="submitButton btn btn-primary" v-on:click="dismiss()">{{ getDismissButtonLabel() }}</button>
        <button class="submitButton closeButton btn" v-on:click="confirm()">{{ getConfirmButtonLabel() }}</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },

  methods: {
    confirm () {
      this.$emit('confirmed')
    },
    dismiss () {
      this.$emit('dismissed')
    },

    getConfirmationText() {
      return this.useEnglishAndFrenchTexts
        ? 'Êtes-vous sûr de vouloir mettre fin à cette discussion / Are you sure you want to end this chat?'
        : 'Are you sure you want to end this chat?'
    },
    getConfirmButtonLabel() {
      return this.useEnglishAndFrenchTexts
        ? 'Oui, fin du chat maintenant / Yes, end chat now'
        : 'Yes, end chat now'
    },
    getDismissButtonLabel() {
      return this.useEnglishAndFrenchTexts
        ? 'Non, je veux continuer / No, I want to continue'
        : 'No, I want to continue'
    }
  },

  props: ['use-english-and-french-texts']
}
</script>

<style scoped>
.submitButton {
  color: #fff !important;
  position: relative;
  display: block;
  width: 70%;
  left: 15%;
}
.confirmationModal { padding: 20px; }
.closeButton { background-color: #a0a0a0; color: #fff; }
.closeButton:hover, .closeButton:enabled:hover { background-color: #6c757d !important; }
.confirmationModalTitle {
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/CloseChatConfirmationModal.vue